import {EitjeButton} from '../../eitje_button'
import {Placeholder} from '../../placeholder'
import {useFilterContext} from '../context'

export const FiltersPlaceholder = props => {
	const {hasFiltered, clearFilters} = useFilterContext()

	if (!hasFiltered) return null

	return (
		<Placeholder
			animation="filter"
			name="reset_filters"
			customButtons={[<EitjeButton iconLeft="arrow-circle-right" t="common.reset_filters" onClick={clearFilters} />]}
			layoutProps={{height: 'unset'}}
			{...props}
		/>
	)
}
